import { Dispatch, ReactNode, SetStateAction, useCallback } from 'react';

import { Edge, EdgeMarkerType, MarkerType } from 'reactflow';

import { FocusedInputRefType } from '@contexts/ExperimentCanvasContext';

export const defaultEdgeOptions = {
    style: {
        strokeWidth: 2,
        stroke: 'black',
    },
    labelStyle: {
        fontSize: '24px', // Default font size for edge labels
    },
    selectable: true,
    deletable: true,
    type: 'default',
    markerEnd: {
        type: MarkerType.ArrowClosed,
        color: 'black',
    },
    label: '',
};

export type CustomEdge = Omit<Edge, 'markerEnd label'> & {
    markerEnd?: EdgeMarkerType;
    label?: ReactNode;
    data?: {
        setY?: Dispatch<SetStateAction<number | undefined>>;
        y?: undefined;
    };
};

type Props = {
    canvasLoaded?: boolean;
    edges: CustomEdge[];
    experiment_id?: string;
    setEdges: (edges: CustomEdge[]) => void;
    focusedInputRef: FocusedInputRefType;
    setSelectedEdge: (edge: CustomEdge | null) => void;
};

const useCanvasEdges = ({ edges, setEdges, setSelectedEdge }: Props) => {
    const handleUpdateEdge = useCallback(
        (edge: CustomEdge) => {
            const filteredEdges = edges.filter((oldEdge) => oldEdge.id !== edge.id);
            const newEdges = [...filteredEdges, edge];
            setSelectedEdge(edge);
            setEdges(newEdges ?? []);
        },
        [edges, setEdges, setSelectedEdge],
    );

    return {
        defaultEdgeOptions,
        handleUpdateEdge,
    };
};

export default useCanvasEdges;
